export default __webpack_public_path__ + "static/media/edit.e8c48308.svg";